var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f7646b;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("g", {
    id: "ic-social-media-whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.35,2.65A12.65,12.65,0,0,0,9.92,25.54l.41,3.82,3.22-2a12.9,12.9,0,0,0,3.8.58,12.66,12.66,0,0,0,0-25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.21,10.17l1.65,1.65a1.13,1.13,0,0,1,0,1.61h0a1.15,1.15,0,0,0,0,1.61l2.45,2.45a1.15,1.15,0,0,0,1.61,0h0a1.13,1.13,0,0,1,1.61,0l1.66,1.66a1.15,1.15,0,0,1,0,1.61l-.58.58a1.24,1.24,0,0,1-.56.31h0A8.63,8.63,0,0,1,11.71,11.31h0a1.11,1.11,0,0,1,.31-.56l.58-.58A1.13,1.13,0,0,1,14.21,10.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsap);
export default __webpack_public_path__ + "static/media/whatsap.e32fd6260f2b98ca1281e1140ff324c5.svg";
export { ForwardRef as ReactComponent };